export const PackageItemLimitType = {
    Boolean: 1,
    Limit: 2
}
export type PackageItemLimitType = typeof PackageItemLimitType[keyof typeof PackageItemLimitType]